import { render, staticRenderFns } from "./FudaoStudentExtendInviteDialog.vue?vue&type=template&id=cd6c9066&scoped=true&"
import script from "./FudaoStudentExtendInviteDialog.vue?vue&type=script&lang=js&"
export * from "./FudaoStudentExtendInviteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6c9066",
  null
  
)

export default component.exports